/**
 * Words and keys the board editor draws by (2026-10-30), kept out of the component file so they can be tested alone.
 */
import type { RangeToken } from "./use-live-tag-data";
import type { WidgetInstance } from "./types";

/** What a range chip shows, said in full on hover. */
export function rangeHint(token: RangeToken | undefined): string {
  switch (token) {
    case undefined:
      return "The latest reading of each tag";
    case "1h":
      return "The last hour";
    case "6h":
      return "The last 6 hours";
    case "24h":
      return "The last 24 hours";
    case "7d":
      return "The last 7 days";
    case "30d":
      return "The last 30 days";
    case "1y":
      return "The last year";
    case "all":
      return "Every reading kept";
  }
}

/**
 * What a widget's fault is reset by: a change to what it draws (its type, settings or data). A widget that could not be
 * drawn is tried again after such an edit. A value that cannot be written out resets nothing more than its type.
 */
export function faultResetKey(widget: Pick<WidgetInstance, "type" | "config" | "dataSource">): string {
  try {
    return JSON.stringify([widget.type, widget.config ?? null, widget.dataSource ?? null]);
  } catch {
    return widget.type;
  }
}
